import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import { Provider } from "react-redux";
import { Toaster } from "react-hot-toast";
import store, { persistor } from "./redux/Store";
import { PersistGate } from "redux-persist/integration/react";
import ProtectedRoute from "./ProtectedRoute";

import Topbar from "./components/layout/topbar";

import AdminDashboard from "./components/dashboard/admin";
import UserDashboard from "./components/dashboard/user";
import MerchantDashboard from "./components/dashboard/merchant";

import MerchantLogin from "./components/login/merchant";
import UserLogin from "./components/login/user";
import AdminLogin from "./components/login/admin";
import UserSignup from "./components/signup/user";
import VerifyEmail from "./components/signup/VerifyEmail";
import Kyc from "./components/signup/Kyc";
import Home from "./components/home/home";

import MerchantSignUp from "./components/signup/merchant";
import AdminSignUp from "./components/signup/admin";
import NewTransaction from "./components/transactions/NewTransaction";
import TransactionComponent from "./components/transactions/transaction";
import TransactionRequest from "./components/transactions/TransactionRequest";
import PendingReceivedReqItem from "./components/transactions/PendingReceivedReqItem";
import PendingSentReqItem from "./components/transactions/PendingSentReqItem";
import ReceivedTransactionItem from "./components/transactions/ReceivedTransactionItem";
import SentTransactionItem from "./components/transactions/SentTransactionItem";
import Account from "./components/account/Account";
import HelpForm from "./components/account/help";
import Profile from "./components/account/profile";
import ContactUs from "./components/account/contact";
import Contract from "./contract/Contract";

function App() {
  const [theme, colorMode] = useMode();
  // eslint-disable-next-line
  const [isSidebar, setIsSidebar] = useState(true);
  const [newUserId, setNewUserId] = useState(null);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Provider store={store}>
          <PersistGate persistor={persistor}>
            <div className="app">
              <Router>
                <Topbar setIsSidebar={setIsSidebar} />
                <div>
                  <Toaster position="top-center" reverseOrder={false} />
                </div>
                <Routes>
                  {/* <Route path="/" element={<Home />} /> */}
                  <Route path="/" element={<Home />} />
                  {/* dashboard routes */}
                  <Route path="/admin" element={<AdminDashboard />} />
                  <Route
                    path="/user"
                    element={
                      <ProtectedRoute>
                        <UserDashboard newUserId={newUserId} />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="/merchant" element={<MerchantDashboard />} />

                  {/* transactions routes */}

                  <Route
                    path="/new"
                    element={
                      <ProtectedRoute>
                        <NewTransaction />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/transactions"
                    element={
                      <ProtectedRoute>
                        <TransactionComponent />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/transactions-request"
                    element={
                      <ProtectedRoute>
                        <TransactionRequest />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/pending-received-transaction/:id"
                    element={
                      <ProtectedRoute>
                        <PendingReceivedReqItem />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/pending-sent-transaction/:id"
                    element={
                      <ProtectedRoute>
                        <PendingSentReqItem />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/received-transaction/:id"
                    element={
                      <ProtectedRoute>
                        <ReceivedTransactionItem />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/sent-transaction/:id"
                    element={
                      <ProtectedRoute>
                        <SentTransactionItem />
                      </ProtectedRoute>
                    }
                  />


                  <Route
                    path="/contract/:id"
                    element={
                      <ProtectedRoute>
                        <Contract />
                      </ProtectedRoute>
                    }
                  />

                  {/* {verify route} */}
                  <Route
                    path="/verify-email"
                    element={<VerifyEmail newUserId={newUserId} />}
                  />
                  <Route
                    path="/Kyc"
                    element={
                      <ProtectedRoute>
                        <Kyc newUserId={newUserId} />
                      </ProtectedRoute>
                    }
                  />

                  {/* {login routes} */}
                  <Route path="/merchant-login" element={<MerchantLogin />} />
                  <Route path="/login" element={<UserLogin />} />
                  <Route path="/admin-login" element={<AdminLogin />} />

                  {/* {signup routes} */}
                  <Route
                    path="/signup"
                    element={<UserSignup setNewUserId={setNewUserId} />}
                  />
                  <Route path="/merchant-sign" element={<MerchantSignUp />} />
                  <Route path="/admin-sign" element={<AdminSignUp />} />

                  <Route
                    path="/account"
                    element={
                      <ProtectedRoute>
                        <Account />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/help"
                    element={
                      <ProtectedRoute>
                        <HelpForm />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/profile"
                    element={
                      <ProtectedRoute>
                        <Profile />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/contact"
                    element={
                      <ProtectedRoute>
                        <ContactUs />
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </Router>
            </div>
          </PersistGate>
        </Provider>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
